import { Grid, MuiThemeProvider, TextField } from '@material-ui/core';
import { customizerTheme } from 'assets/theme';
import variables from 'assets/theme/variables';
import ColorPicker from 'components/Shared/ColorPicker';
import { WithStyles } from 'decorators/withStyles';
import rgbaToHex, { hexToRgba } from 'helpers/rgbaToHex';
import * as React from 'react';
import { PureComponent } from 'react';

export interface IColorPickerProps {
  handleChangeColor: (color: string) => void;
}

interface IState {
  color: string;
  RBGFormat?: boolean;
}

interface IProps extends IColorPickerProps {
  classes?: any;
  label: string;
  value?: string;
  RGBFormat?: boolean;
}

@WithStyles(theme => ({
  root: {
    maxHeight: 90
  },
  swatch: {
    height: 47.5,
    borderRadius: '0 4px 4px 0',
    border: `1px solid ${theme.variables.colors['inputBorder']}`,
    cursor: 'pointer'
  },
  swatchGrid: {
    padding: '32px 0'
  },
  input: {
    borderRadius: '4px 0 0 4px',
    borderRight: 'none'
  },
  sketchPicker: {
    marginTop: 8,
    position: 'absolute',
    zIndex: 1
  }
}))
export default class ActionButton extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      color: props.value || '#fff'
    };
  }

  componentDidMount() {
    const currentColor = `${this.props.value}`;

    if (!currentColor) {
      this.setState({ color: '#FFFFFF' });
      return;
    }

    if (this.props.RGBFormat) {
      const color = rgbaToHex(currentColor);
      this.setState({ color });
      return;
    }

    if (currentColor.charAt(0) !== '#') {
      this.setState({ color: '#' + currentColor });
    }
  }

  handleDisplaySketchPicker = (event: any) => {
    ColorPicker.getColor(event, this.state.color).subscribe(color => {
      this.setState({ color: color.hex });

      const formattedColor = this.props.RGBFormat
        ? `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`
        : color.hex;
      this.props.handleChangeColor(formattedColor);
    });
  };

  changeColor = (event: any) => {
    let color = event.target.value;

    if (color.charAt(0) !== '#') {
      color = '#' + color;
    }

    this.setState({ color });
    this.props.handleChangeColor(color);

    if (this.props.RGBFormat && event.target.value.length >= 7) {
      this.props.handleChangeColor(hexToRgba(color, 1));
    }
  };

  render() {
    const { classes } = this.props;
    const { color } = this.state;

    const styles = {
      swatch: {
        background: color,
        borderColor: color.toLowerCase().includes('#fff') ? variables.colors['inputBorder'] : color
      }
    };

    return (
      <div className={classes.root}>
        <MuiThemeProvider theme={customizerTheme}>
          <Grid container alignItems="flex-start">
            <Grid item xs={9}>
              <TextField
                label={this.props.label}
                onChange={this.changeColor}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  disableUnderline: true,
                  className: classes.input
                }}
                inputProps={{
                  maxLength: 7
                }}
                fullWidth
                value={color}
                margin="normal"
              />
            </Grid>
            <Grid item xs={3} className={classes.swatchGrid}>
              <div className={classes.swatch} style={styles.swatch} onClick={this.handleDisplaySketchPicker}>
                &nbsp;
              </div>
            </Grid>
          </Grid>
        </MuiThemeProvider>
      </div>
    );
  }
}
